var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState } from 'react';
import { Button, Card, Space, Table, Tag, message } from 'antd';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createDiagnosisIcon, fetchAdminDiagnosisIcons, updateDiagnosisIcon, updateDiagnosisIconSortOrder } from '../cores/api/api-dashboard';
import { DIAGNOSIS_ICON_QUERY_KEY, STATUS_COLOR_MAP, STATUS_LABEL_MAP } from '../contants/option';
import DiagnosisIconFormModal from './icon-form';
const resolveIconStatus = icon => {
    if (!icon.active)
        return 'inactive';
    return 'active';
};
export default function DiagnosisIconPage({ embedded = false }) {
    var _a;
    const _message$useMessage = message.useMessage(), _message$useMessage2 = _slicedToArray(_message$useMessage, 2), messageApi = _message$useMessage2[0], contextHolder = _message$useMessage2[1];
    const _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), isModalOpen = _useState2[0], setIsModalOpen = _useState2[1];
    const _useState3 = useState(null), _useState4 = _slicedToArray(_useState3, 2), editingIcon = _useState4[0], setEditingIcon = _useState4[1];
    const _useState5 = useState(null), _useState6 = _slicedToArray(_useState5, 2), draggingIconId = _useState6[0], setDraggingIconId = _useState6[1];
    const queryClient = useQueryClient();
    const _useQuery = useQuery({
        queryKey: DIAGNOSIS_ICON_QUERY_KEY,
        queryFn: () => fetchAdminDiagnosisIcons({
            per_page: 100
        })
    }), data = _useQuery.data, isLoading = _useQuery.isLoading;
    const createMutation = useMutation({
        mutationFn: params => createDiagnosisIcon(params),
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!response.success) {
                throw new Error(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.join(', ')) || response.error || 'Create failed');
            }
            yield queryClient.invalidateQueries({
                queryKey: DIAGNOSIS_ICON_QUERY_KEY
            });
            messageApi.success('Icon created.');
            closeModal();
        })
    });
    const updateMutation = useMutation({
        mutationFn: ({ id, params }) => updateDiagnosisIcon(id, params),
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!response.success) {
                throw new Error(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.join(', ')) || response.error || 'Update failed');
            }
            yield queryClient.invalidateQueries({
                queryKey: DIAGNOSIS_ICON_QUERY_KEY
            });
            messageApi.success('Icon updated.');
            closeModal();
        })
    });
    const reorderMutation = useMutation({
        mutationFn: updateDiagnosisIconSortOrder,
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!response.success) {
                throw new Error(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.join(', ')) || response.error || 'Reorder failed');
            }
            yield queryClient.invalidateQueries({
                queryKey: DIAGNOSIS_ICON_QUERY_KEY
            });
            messageApi.success('Icon order updated.');
        })
    });
    const icons = (_a = data === null || data === void 0 ? void 0 : data.data) !== null && _a !== void 0 ? _a : [];
    const getCreateSortOrder = () => {
        if (!icons.length)
            return 1;
        const sortOrders = icons.map(icon => Number(icon.sort_order) || 0);
        return Math.max(...sortOrders) + 1;
    };
    const openCreateModal = () => {
        setEditingIcon(null);
        setIsModalOpen(true);
    };
    const openEditModal = icon => {
        setEditingIcon(icon);
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
        setEditingIcon(null);
    };
    const handleSubmit = (payload) => __awaiter(this, void 0, void 0, function* () {
        try {
            if (editingIcon) {
                yield updateMutation.mutateAsync({
                    id: editingIcon.id,
                    params: payload
                });
            }
            else {
                yield createMutation.mutateAsync(payload);
            }
        }
        catch (error) {
            messageApi.error(error.message || 'Save failed.');
        }
    });
    const handleDropIcon = (targetIcon) => __awaiter(this, void 0, void 0, function* () {
        const draggedIcon = icons.find(icon => icon.id === draggingIconId);
        setDraggingIconId(null);
        if (!draggedIcon || draggedIcon.id === targetIcon.id)
            return;
        const fromIndex = icons.findIndex(icon => icon.id === draggedIcon.id);
        const toIndex = icons.findIndex(icon => icon.id === targetIcon.id);
        if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex)
            return;
        try {
            yield reorderMutation.mutateAsync({
                id: draggedIcon.id,
                over_id: targetIcon.id,
                place: fromIndex < toIndex ? 'after' : 'before'
            });
        }
        catch (error) {
            messageApi.error(error.message || 'Reorder failed.');
        }
    });
    const columns = [{
            title: 'アイコン',
            dataIndex: 'image_url',
            width: 140,
            render: (value, record) => /*#__PURE__*/ React.createElement("div", {
                className: "flex h-[72px] w-[72px] items-center justify-center overflow-hidden rounded-lg border border-[#e5e7eb] bg-[#f8fafc]"
            }, value ? /*#__PURE__*/ React.createElement("img", {
                src: value,
                alt: record.title || 'icon',
                className: "h-full w-full object-cover"
            }) : /*#__PURE__*/ React.createElement("span", {
                className: "text-[12px] text-[#6b7280]"
            }, "No image"))
        }, {
            title: 'タイトル',
            dataIndex: 'title',
            render: value => /*#__PURE__*/ React.createElement("div", {
                className: "truncate text-[12px] text-[#374151]"
            }, value || '-')
        }, {
            title: '説明',
            dataIndex: 'description',
            render: value => /*#__PURE__*/ React.createElement("div", {
                className: "line-clamp-2 text-[12px] text-[#374151]"
            }, value || '-')
        }, {
            title: 'ステータス',
            width: 100,
            render: (_, record) => {
                const status = resolveIconStatus(record);
                return /*#__PURE__*/ React.createElement(Tag, {
                    color: STATUS_COLOR_MAP[status]
                }, STATUS_LABEL_MAP[status]);
            }
        }, {
            title: '',
            key: 'action',
            width: 100,
            render: (_, record) => /*#__PURE__*/ React.createElement(Space, null, /*#__PURE__*/ React.createElement(Button, {
                onClick: () => openEditModal(record)
            }, "\u7DE8\u96C6"))
        }];
    return /*#__PURE__*/ React.createElement("div", {
        className: embedded ? '' : 'min-h-screen bg-[#f5f5f5] px-6 py-6'
    }, contextHolder, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto"
    }, /*#__PURE__*/ React.createElement(Card, {
        className: "mb-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-end justify-end gap-4"
    }, /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        onClick: openCreateModal
    }, "\u30A2\u30A4\u30B3\u30F3\u8FFD\u52A0"))), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Table, {
        rowKey: "id",
        loading: isLoading,
        columns: columns,
        dataSource: icons,
        pagination: {
            pageSize: 10
        },
        scroll: {
            x: 960
        },
        onRow: record => ({
            draggable: true,
            onDragStart: () => {
                setDraggingIconId(record.id);
            },
            onDragOver: event => {
                event.preventDefault();
            },
            onDrop: () => {
                void handleDropIcon(record);
            },
            onDragEnd: () => {
                setDraggingIconId(null);
            },
            className: draggingIconId === record.id ? 'cursor-grabbing opacity-60' : 'cursor-grab'
        })
    }))), /*#__PURE__*/ React.createElement(DiagnosisIconFormModal, {
        open: isModalOpen,
        editingIcon: editingIcon,
        loading: createMutation.isPending || updateMutation.isPending,
        getCreateSortOrder: getCreateSortOrder,
        onCancel: closeModal,
        onSubmit: handleSubmit
    }));
}
